import { subdomainTypes } from "../../context/availableSubdomains";
import { IconNames } from "../Icon/types";

export interface Category {
  title: string;
  category: string;
  route: string;
  link?: string;
  isExternalLink?: boolean;
  icon: IconNames;
}

export const CATEGORIES: Category[] = [
  {
    title: "Cart",
    category: "cart",
    route: "/store/cart",
    icon: "ShoppingCartWhite",
  },
  {
    title: "Quick Order",
    category: "quickorder",
    route: "/quick-order",
    icon: "Pencil",
  },
  {
    title: "Saved Orders",
    category: "savedorders",
    route: "/saved-orders",
    icon: "Save",
  },
  {
    title: "Order Import",
    category: "orderimport",
    route: "/order-uploader",
    icon: "FileUpload",
  },
  {
    title: "Order History",
    category: "orderhistory",
    route: "/order-history",
    icon: "BoxOpen",
  },
  {
    title: "Transactions",
    category: "transactions",
    route: "/transactions",
    icon: "CreditCard",
  },
  {
    title: "Preferences",
    category: "preferences",
    route: "/preferences",
    icon: "Cog",
  },
  {
    title: "Promotions",
    category: "promotions",
    route: "/store/cart",
    icon: "StarWhite",
  },
];

export interface webData {
  title: string;
  icon: IconNames;
  links: Record<subdomainTypes, string>;
  availableBranches: subdomainTypes[];
}

export const webDataLinks: webData[] = [
  {
    title: "Consolidated Media Library",
    icon: "PhotoVideo",
    links: {
      [subdomainTypes.NZ]:
        "https://drive.google.com/drive/folders/1b0psR81rxlQPe_O8t4WkgyUHVx9Mq_i2?usp=drive_link",
      [subdomainTypes.AU]:
        "https://drive.google.com/drive/folders/1b0psR81rxlQPe_O8t4WkgyUHVx9Mq_i2?usp=drive_link",
      [subdomainTypes.CA]:
        "https://drive.google.com/drive/folders/1uj8r3Qxc6hTkdreQ9cArfFpdo-HbY-Kc?usp=drive_link",
    },
    availableBranches: [subdomainTypes.NZ, subdomainTypes.AU, subdomainTypes.CA],
  },
  {
    title: "Digital Catalogues",
    icon: "StarWhite",
    links: {
      [subdomainTypes.NZ]: "https://www.fashionbiz.co.nz/catalogue",
      [subdomainTypes.AU]: "https://www.fashionbiz.com.au/catalogue",
      [subdomainTypes.CA]: "https://www.fashionbiz.ca/catalogue",
    },
    availableBranches: [subdomainTypes.NZ, subdomainTypes.AU, subdomainTypes.CA],
  },
  {
    title: "Web Data",
    icon: "PhotoVideo",
    links: {
      [subdomainTypes.NZ]:
        "https://drive.google.com/drive/folders/1GxxxRt9NfumwrIv8S70jA6_yqoCuNGgz?usp=drive_link",
      [subdomainTypes.AU]:
        "https://drive.google.com/drive/folders/1JpiF1ou0_c98p9jiuKC2taPC5bz3caux?usp=drive_link",
      [subdomainTypes.CA]:
        "https://drive.google.com/drive/folders/1QDN3EFfMZM4irzpMhDlB9TpMK8gsTaue?usp=drive_link",
    },
    availableBranches: [subdomainTypes.NZ, subdomainTypes.AU, subdomainTypes.CA],
  },
];
